import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IUPairAddOrderFormValues,
  IUPairTableReport,
} from "../../Interfaces/uPairInterfaces";

interface IUPairSlice {
  addOrderFormValues: IUPairAddOrderFormValues | null;
  orderTableFetchDataFlag: boolean;
  tradeTableFetchDataFlag: boolean;
  editOrderRowValues: IUPairTableReport | null;
}

const initialState: IUPairSlice = {
  addOrderFormValues: {} as IUPairAddOrderFormValues,
  orderTableFetchDataFlag: false,
  tradeTableFetchDataFlag: false,
  editOrderRowValues: null,
};

const UPairSlice = createSlice({
  name: "uPair",
  initialState,
  reducers: {
    setUPairAddOrderFormValues: (
      store,
      action: PayloadAction<IUPairAddOrderFormValues>
    ) => {
      store.addOrderFormValues = action.payload;
    },
    onUPairOrderFormValuesChange: (
      store,
      action: PayloadAction<{
        name: string;
        value: any;
        name2?: string;
        value2: any;
      }>
    ) => {
      if (action.payload.name2)
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
          [action.payload.name2]: action.payload.value2,
        } as IUPairAddOrderFormValues;
      else
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
        } as IUPairAddOrderFormValues;
    },
    setUPairOrderTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>
    ) => {
      if (store.orderTableFetchDataFlag !== action.payload)
        store.orderTableFetchDataFlag = action.payload;
    },
    setUPairTradeTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>
    ) => {
      if (store.tradeTableFetchDataFlag !== action.payload)
        store.tradeTableFetchDataFlag = action.payload;
    },
    setUPairEditRowValues: (
      store,
      action: PayloadAction<IUPairTableReport | null>
    ) => {
      store.editOrderRowValues = action.payload;
    },
  },
});

export const {
  setUPairAddOrderFormValues,
  setUPairOrderTableFetchDataFlag,
  setUPairTradeTableFetchDataFlag,
  onUPairOrderFormValuesChange,
  setUPairEditRowValues,
} = UPairSlice.actions;
export default UPairSlice.reducer;
